import { Navigate, useLocation } from 'react-router-dom';
import { homePathFor, useAuth } from '../lib/auth';
import type { CognitoGroup } from '@fin/shared/enums';

export function ProtectedRoute({
  children,
  requireGroup,
}: {
  children: React.ReactNode;
  /** Optional group gate. If set, user must be in at least one of these groups. */
  requireGroup?: CognitoGroup[];
}) {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-500">Loading…</div>
    );
  }
  if (status === 'unauthenticated' || !user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (requireGroup && !requireGroup.some((g) => user.groups.includes(g))) {
    const home = homePathFor(user.groups);
    // Fall back to /login rather than loop when even the home page is off-limits.
    if (home === location.pathname) return <Navigate to="/login" replace />;
    return <Navigate to={home} replace />;
  }
  return <>{children}</>;
}
